import { render, staticRenderFns } from "./CommunicationTypeFilter.vue?vue&type=template&id=67cc9e36&"
import script from "./CommunicationTypeFilter.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports